export class UuidPaths {
  public static readonly UUID_NAMESPACE = '00000000-0000-0000-0000-000000000000';
}
